import { render } from "./PostsToolbarModal.vue?vue&type=template&id=bfdb8530&ts=true"
import script from "./PostsToolbarModal.vue?vue&type=script&lang=ts"
export * from "./PostsToolbarModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__